import React, { Fragment } from 'react';
import { map, get, isNull } from 'lodash/fp';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ButtonGroup, IconButton, Icon } from 'rsuite';

const mapWithKey = map.convert({ cap: false });
const PackageItem = styled.div`
  float: right;
  width: 380px;
  margin-right: 38px;
  margin-bottom: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid #ddd;
`;

const ItemLabel = styled.span`
  width: 130px;
  display: inline-block;
  vertical-align: -webkit-baseline-middle;
`;

const ItemQty = styled(ItemLabel)`
  width: 30px;
  text-align: right;
`;

const DeletedItemLabel = styled(ItemLabel)`
  text-decoration: line-through;
`;

const DeletedItemQty = styled(ItemQty)`
  text-decoration: line-through;
`;

const PackageItemButtons = styled(ButtonGroup)`
  float: right;
`;

const PackageItemsList = ({
  packageItems,
  onIncrementQty,
  onDecrementQty,
  onUndoDelete,
  onDelete,
  allowEdit
}) => (
  <div>
    {mapWithKey(
      (packageItem, key) => (
        <PackageItem key={key}>
          {packageItem.deleted ? (
            <Fragment>
              <DeletedItemLabel>
                {get('item.name', packageItem)}
              </DeletedItemLabel>
              {!isNull('zone') && (
                <ItemLabel>{get('zone.name', packageItem)}</ItemLabel>
              )}
              <DeletedItemQty>{packageItem.quantity}</DeletedItemQty>
            </Fragment>
          ) : (
            <Fragment>
              <ItemLabel>{get('item.name', packageItem)}</ItemLabel>
              {!isNull('zone') && (
                <ItemLabel>{get('zone.name', packageItem)}</ItemLabel>
              )}
              <ItemQty>{packageItem.quantity}</ItemQty>
            </Fragment>
          )}
          <PackageItemButtons>
            <IconButton
              size="xs"
              disabled={
                !allowEdit || packageItem.quantity === 1 || packageItem.deleted
              }
              onClick={() => onDecrementQty(packageItem)}
              icon={<Icon icon="minus-circle" />}
            />
            <IconButton
              size="xs"
              disabled={!allowEdit || packageItem.deleted}
              onClick={() => onIncrementQty(packageItem)}
              icon={<Icon icon="plus-circle" />}
            />
            {packageItem.deleted ? (
              <IconButton
                size="xs"
                onClick={() => onUndoDelete(packageItem)}
                icon={<Icon icon="undo" />}
              />
            ) : (
              <IconButton
                size="xs"
                disabled={!allowEdit}
                onClick={() => onDelete(packageItem)}
                icon={<Icon icon="trash" />}
              />
            )}
          </PackageItemButtons>
        </PackageItem>
      ),
      packageItems
    )}
  </div>
);

PackageItemsList.propTypes = {
  packageItems: PropTypes.arrayOf(PropTypes.shape({})),
  onIncrementQty: PropTypes.func.isRequired,
  onDecrementQty: PropTypes.func.isRequired,
  onUndoDelete: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  allowEdit: PropTypes.bool
};

PackageItemsList.defaultProps = {
  packageItems: [],
  allowEdit: true
};

export default PackageItemsList;
